import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

const fadeUp = {
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section id="missione" data-testid="manifesto-section" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p {...fadeUp} className="text-xs md:text-sm font-semibold uppercase tracking-[0.22em] text-terra mb-6">
          {t.manifesto.eyebrow}
        </motion.p>
        <div className="grid lg:grid-cols-12 gap-8 mb-20">
          <motion.h2
            {...fadeUp}
            className="lg:col-span-5 font-serif font-medium tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            {t.manifesto.title}
          </motion.h2>
          <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.15 }} className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-base md:text-lg leading-relaxed text-inksoft">
              {t.manifesto.intro}
            </p>
            <div className="mt-8 overflow-hidden rounded-3xl border border-line shadow-[0_20px_60px_rgba(45,50,43,0.10)]">
              <img
                src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=1200&q=80"
                alt="Equipe di operatori che unisce le mani in segno di comunità"
                loading="lazy"
                className="w-full h-56 lg:h-64 object-cover"
                data-testid="manifesto-image"
              />
            </div>
          </motion.div>
        </div>

        <div>
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="grid lg:grid-cols-12 gap-4 lg:gap-8 py-10 lg:py-14 border-t border-line group"
            >
              <div className="lg:col-span-2">
                <span className="font-serif text-6xl lg:text-7xl font-medium text-sand group-hover:text-terra transition-colors duration-500">
                  {c.num}
                </span>
              </div>
              <h3 className="lg:col-span-3 font-serif text-3xl lg:text-4xl font-medium text-ink self-start">
                {c.title}
              </h3>
              <p className="lg:col-span-6 lg:col-start-7 text-base md:text-lg leading-relaxed text-inksoft">
                {c.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
